import { z } from "zod";
import { CreatePageSchema } from "~/lib/pages";
import { CreatePage, DeletePage } from "~/lib/pages.server";
import { $API, $SERVER } from "~/util/Loaders";
import { loadMarkdown } from "~/util/Markdown.server";

export const previewPageApi = $API({
  path: "api/pages/preview",
  method: "POST",
  parser: z
    .object({
      content: z.string(),
    })
    .strict(),
})(
  $SERVER?.(async (cx) => {
    const sess = cx.req.sess;
    if (!sess) {
      return { t: "error" as const, error: "The user is not logged in." };
    }

    return {
      t: "success" as const,
      data: {
        result: {
          content: await loadMarkdown(
            cx.input.content,
            cx.gd.all_gd!,
            cx.realm.lang,
            cx.realm.game,
          ),
        },
      },
    };
  }),
);

export const editPageApi = $API({
  path: "api/pages/edit",
  method: "POST",
  parser: CreatePageSchema,
})(
  $SERVER?.(async (cx) => {
    const sess = cx.req.sess;
    if (!sess) {
      return { t: "error" as const, error: "The user is not logged in." };
    }

    return await CreatePage({ sess, input: cx.input });
  }),
);

export const deletePageApi = $API({
  path: "api/pages/delete",
  method: "POST",
  parser: z
    .object({
      pageId: z.number(),
    })
    .strict(),
})(
  $SERVER?.(async (cx) => {
    const sess = cx.req.sess;
    if (!sess) {
      return { t: "error" as const, error: "The user is not logged in." };
    }

    return await DeletePage({ sess, input: cx.input });
  }),
);
